import { requireAuth } from '@/features/auth/guards/require-auth'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { WorkOrdersGlobalListPage } from '@/features/work-orders/pages/work-orders-global-list-page'
import {
  WO_GLOBAL_LIST_LIMIT,
  workOrdersListQuery,
} from '@/features/work-orders/queries/work-orders-list-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

// Filters live in the URL: a reload or Back keeps them, and the list query
// key follows them (the page keeps the previous rows while a new key loads).
const searchSchema = z.object({
  project: z.coerce.number().int().positive().optional().catch(undefined),
  status: z.enum(['draft', 'posted']).optional().catch(undefined),
})

export const Route = createFileRoute('/_app/work-orders/')({
  validateSearch: searchSchema,
  beforeLoad: requireAuth,
  loaderDeps: ({ search }) => ({ project: search.project, status: search.status }),
  loader: ({ deps, context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(
        workOrdersListQuery({
          project_id: deps.project,
          status: deps.status,
          limit: WO_GLOBAL_LIST_LIMIT,
          offset: 0,
        }),
      ),
      queryClient.ensureQueryData(projectsListQuery()),
    ]),
  component: WorkOrdersGlobalListPage,
  staticData: { crumb: messages.crumbs.workOrders },
})
